
import state from './state';
import Store from '../../base/index';


export default class RsvpSeatplanElements extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng});
    }
}


// WEBPACK FOOTER //
// ./src/app/store/seatplans/rse/index.js